import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { DynamicComponent } from '../DynamicComponent';

const drawerWidth = 350;

const openedMixin = () => ({
  width: drawerWidth,
  border: '1px solid lightgray',
  borderRadius: '30px',
  marginRight: '12px',
  padding: '12px 16px',
});

const closedMixin = () => ({
  width: '0px',
});

const CustomDrawer = styled('div', { shouldForwardProp: (prop) => prop !== 'open' })(({ theme, open }) => ({
  width: drawerWidth,
  height: '99%',
  position: 'absolute',
  right: 0,
  overflow: 'hidden',
  transition: 'width 0.3s linear',
  marginTop: '4px',
  ...(open && {
    ...openedMixin(theme),
    '&.right-drawer': openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    '&.right-drawer': closedMixin(theme),
  }),
}));

export const Drawer = ({ open = false, component = null, close = () => {}, props = null }) => {
  return (
    <CustomDrawer
      open={open}
      className="right-drawer"
    >
      <Box
        sx={{ width: '100%', height: '100%' }}
        role="presentation"
        className="right-drawer__content"
      >
        {open && component && (
          <DynamicComponent
            is={component}
            close={close}
            {...props}
          />
        )}
      </Box>
    </CustomDrawer>
  );
};
